module.exports = __webpack_public_path__ + "img/blond.0201cb69.png";